import { render, staticRenderFns } from "./OnboardingBirthday.vue?vue&type=template&id=6df9f074&scoped=true&"
import script from "./OnboardingBirthday.vue?vue&type=script&lang=js&"
export * from "./OnboardingBirthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df9f074",
  null
  
)

export default component.exports